// referring to src/pages/globalpedia/components/COSFileList/components/FileItemActions/index.tsx
// but with additional visibleActions props so that we can control the actions visibility

import React from 'react';
import { Bubble } from 'tea-component';
import OpenEyesIcon from '@sg/assests/svg/open-eyes.svg';
import DownloadIcon from '@sg/assests/svg/download.svg';
import ShareLinkIcon from '@sg/assests/svg/share-link.svg';
import './index.scss';

interface IFileItemActionsProps extends IBaseProps {
  previewTipsVisible: true | undefined;
  copyTips: string;
  copyTipsVisible: true | undefined;
  onPreview?: () => void;
  onDownload?: () => void;
  onShare?: () => void;
  visibleActions?: {
    preview?: boolean;
    download?: boolean;
    share?: boolean;
  };
}

const FileItemActions: React.FC<IFileItemActionsProps> = (props) => {
  const {
    previewTipsVisible,
    copyTips,
    copyTipsVisible,
    onPreview,
    onDownload,
    onShare,
    visibleActions = { preview: true, download: true, share: true }
  } = props;

  const showPreview = visibleActions.preview !== false;
  const showDownload = visibleActions.download !== false;
  const showShare = visibleActions.share !== false;

  // Calculate if we need dividers (only show between visible actions)
  const visibleCount = [showPreview, showDownload, showShare].filter(Boolean).length;
  const showFirstDivider = showPreview && (showDownload || showShare);
  const showSecondDivider = showPreview && showDownload && showShare;

  return (
    <ul className="dbg-common-file-item__file-action-list dbs-common-file-item__file-action-list">
      {showPreview && (
        <li className="dbg-common-file-item__file-action-item">
          {/* <Bubble key={`action-preview-bubble-${previewTipsVisible}`} dark content="Preview" visible={previewTipsVisible}> */}
          {/* New approach: bubble shows only when hovering over the icon */}
          <Bubble dark content="Preview" trigger="hover">
            <span
              className="dbg-common-file-item__file-action-icon-wrapper"
              onClick={(e) => {
                e.stopPropagation();
                onPreview?.();
              }}
            >
              <img src={OpenEyesIcon} alt="Preview" />
            </span>
          </Bubble>
          {/* Old approach: controlled visibility via previewTipsVisible prop (triggered by file name hover) */}
          {/* <Bubble key={`action-preview-bubble-${previewTipsVisible}`} dark content="Preview" visible={previewTipsVisible}>
            <span
              className="dbg-common-file-item__file-action-icon-wrapper"
              onClick={(e) => {
                e.stopPropagation();
                onPreview?.();
              }}
            >
              <img src={OpenEyesIcon} alt="Preview" />
            </span>
          </Bubble> */}
        </li>
      )}
      {showFirstDivider && (
        <li className="dbg-common-file-item__file-action-item dbs-common-file-item__file-action-item-divider"></li>
      )}
      {showDownload && (
        <li style={{ top: -1 }} className="dbg-common-file-item__file-action-item">
          <Bubble dark content="Download">
            <span
              className="dbg-common-file-item__file-action-icon-wrapper"
              onClick={(e) => {
                e.stopPropagation();
                onDownload?.();
              }}
            >
              <img src={DownloadIcon} alt="Download" />
            </span>
          </Bubble>
        </li>
      )}
      {/* {showDownload && showShare && (
        <li className="dbg-common-file-item__file-action-item dbs-common-file-item__file-action-item-divider"></li>
      )} */}
      {showShare && (
        <li className="dbg-common-file-item__file-action-item">
          <Bubble key={`action-copy-bubble-${copyTipsVisible}`} dark content={copyTips} visible={copyTipsVisible}>
            <span
              className="dbg-common-file-item__file-action-icon-wrapper"
              onClick={(e) => {
                e.stopPropagation();
                onShare?.();
              }}
            >
              <img src={ShareLinkIcon} alt="Copy Link" />
            </span>
          </Bubble>
        </li>
      )}
    </ul>
  );
};

export default FileItemActions;
